import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Unsubscribe = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Processing your request...');
  const [reroutingMessage, setReroutingMessage] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const email = queryParams.get('email');

    const unsubscribe = async () => {
      try {
        const response = await fetch(`https://simplyigbo-backend.onrender.com/api/unsubscribe?token=${token}&email=${email}`, {
          method: 'POST',
        });

        const data = await response.json();
        if (response.ok) {
          setMessage('You have been unsubscribed from the newsletter.');
          setReroutingMessage('Rerouting to the main page in 20 seconds...');
          setTimeout(() => {
            navigate('/');
          }, 20000); // 20 seconds delay
        } else {
          setMessage(data.error || 'Failed to unsubscribe.');
        }
      } catch (error) {
        setMessage('An error occurred while processing your request.');
      }
    };

    unsubscribe();
  }, [location.search, navigate]);

  return (
    <div style={{ backgroundColor: '#ff7c0a', color: '#ffffff', fontFamily: 'Arial, sans-serif', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
      <div style={{ textAlign: 'center' }}>
        <p>{message}</p>
        {reroutingMessage && <p>{reroutingMessage}</p>}
      </div>
    </div>
  );
};

export default Unsubscribe;